// extracted by mini-css-extract-plugin
module.exports = {"item":"NftGridItem_item__3oHH3"};